import { trackAction } from '../../../shared/utils/analytics/analytics';

import { PRODUCT_TYPES } from '../../../shared/constants/products';

function simplifyCategoryName(name) {
  if (!name) {
    return '';
  }
  return name
    .toLowerCase()
    .split(' ')
    .join('_')
    .replace(/&_/g, '')
    .replace(/[/-]/g, '_');
}

export function shopAction({
  category,
  parentCategory,
  productType,
  isGrid,
  shopAll
}) {
  if (!category) {
    return null;
  }
  const base = `shop_category`;
  let eventIdentifier = '';
  let payload = {};
  const { name: pName, superCategories: parentSuperCategories } =
    parentCategory || {};
  const parentName = simplifyCategoryName(pName);

  const prodType = productType === PRODUCT_TYPES.TIRES ? 'tire' : 'wheel';
  const { name } = category || {};
  const categoryName = simplifyCategoryName(name);

  const type = isGrid ? parentName : categoryName;
  const brand = isGrid ? categoryName : parentName;

  if (productType === PRODUCT_TYPES.ACCESSORIES) {
    eventIdentifier = `${base}_accessory`;
    payload.accessory_type = shopAll ? parentName : categoryName;
  }

  if (/Brands/i.test(parentSuperCategories?.[0]?.name)) {
    eventIdentifier = `${base}_${prodType}_brand`;
    payload[`${prodType === 'tire' ? 'tire_type' : 'wheel_style'}`] = shopAll
      ? 'all'
      : type;
    payload[`${prodType}_brand`] = brand;
  } else if (/Type/i.test(parentSuperCategories?.[0]?.name)) {
    eventIdentifier = `${base}_tire_type`;
    payload.tire_type = type;
    payload.tire_brand = shopAll ? 'all' : brand;
  } else if (/Finish/i.test(parentSuperCategories?.[0]?.name)) {
    eventIdentifier = `${base}_wheel_style`;
    payload.wheel_type = type;
    payload.wheel_brand = shopAll ? 'all' : brand;
  } else if (/Vehicle/i.test(parentSuperCategories?.[0]?.name)) {
    eventIdentifier = `${base}_${prodType}_vehicle_type`;
    payload.vehicle_type = type;
    payload.tire_brand = shopAll ? 'all' : brand;
  } else {
    return null;
  }

  trackAction(eventIdentifier, payload);
}
